
export default {
    name: 'PackageTable',
    props: {
        tableData: {
            type: Array,
            default: () => []
        },
        selectedIndex: {
            type: Number,
            default: 0
        },
        props: {
            type: Array,
            default: () => []
        },
        feeDataList: {
            type: Array,
            default: () => []
        },
        canEditSkus: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        calculateAmount(data) {
            const price = data.skuPrice || data.price
            if (!price || !this.feeDataList) {
                return {
                    show: false,
                    list: [],
                    income: 0,
                    totalServiceFee: 0
                }
            }
            // 计算服务费
            const feeResult = []
            this.feeDataList.forEach(item => {
                console.log('item====', item);
                let fee = {
                    fee: 0,
                    name: item.feeTypeName
                }
                let targetFee = item.fees.find(feeItem => feeItem.priceMin <= price && feeItem.priceMax > price)
                if (!targetFee) return

                if (targetFee.feeWay === 'FIXED') {
                    fee.fee = targetFee.fee.toFixed(2)
                    fee.tip = `${fee.name}固定￥${fee.fee}`
                } else {
                    fee.fee = (price * (targetFee.fee / 100)).toFixed(2)
                    fee.tip = `${fee.name}费率${targetFee.fee}% ￥${fee.fee}`
                }
                if (!fee.fee) return
                feeResult.push(fee)
            })

            const totalServiceFee = feeResult.reduce((total, item) => total + Number(item.fee), 0)

            return {
                show: !!feeResult.length,
                list: feeResult,
                income: (price - totalServiceFee).toFixed(2),
                totalServiceFee: totalServiceFee.toFixed(2),
            }
        },
        handleSwitchChange(index) {
            this.$emit('toggle-status', index)
        }
    }
}
